import { useAppDispatch, useAppSelector } from "@builder/store/store";
import "./style.scss";
import { popupMap } from "./helper";
import { closePopup } from "@builder/store/slices/popupSlice";
import React from "react";

const noPaddingPopups = ["templateLibrary", "fullDesignSets", "logout", "dynamicData", "pages"];

const Popup: React.FC = () => {
    const dispatch = useAppDispatch();
    const popup = useAppSelector(state => state.popup);

    const handleWrapperClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.currentTarget === e.target) {
            dispatch(closePopup());
        }
    };

    return popup.popups.length > 0 ? (
        <div className="popup-wrapper" onClick={handleWrapperClick}>
            <div className="popup" style={noPaddingPopups.includes(popup.popups[popup.popups.length - 1]) ? { padding: 0 } : {}}>
                {popupMap[popup.popups[popup.popups.length - 1]]}
            </div>
        </div>
    ) : null;
};

export default Popup;
